mutation updateWatchlist($watchlist: [String]) {
    updateWatchlist(watchlist: $watchlist)
}
